module.exports = __webpack_public_path__ + "img/首页头图2.0ad6ed16.png";